import React from 'react';
import { motion } from 'framer-motion';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1, ease: 'easeInOut' }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { type: 'spring', stiffness: 100, damping: 12 }
  }
};

const sectionFadeIn = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.7, ease: 'easeInOut' },
  viewport: { once: true, amount: 0.2 }
};

export default function ProblemSection() {
  const problems = [
    {
      emoji: '📅',
      title: 'One Month Full Clients. Next Month Nothing?',
      desc: 'Some months your calendar is packed. Some months it\'s completely empty. Neenga good coach dhan. But without a system, income will always be unpredictable.'
    },
    {
      emoji: '📱',
      title: 'Always Busy, But Income Not Growing?',
      desc: 'You\'re posting content. Attending sessions. Creating reels. But real sales are still low. Whole day work pannreenga, but results don\'t match your effort.'
    },
    {
      emoji: '💬',
      title: 'Too Many Enquiries, Zero Serious Clients?',
      desc: 'People message you. Ask for details. Then disappear or say, "Just exploring." Free seekers neraya irukaanga. But paying clients romba kammi.'
    },
    {
      emoji: '💰',
      title: 'You Know Your Value. Then Why Charge So Low?',
      desc: 'You\'ve invested in courses, certifications, experience. But still hesitate to price confidently. "Will they pay this much?" nu doubt varudhaa?'
    },
    {
      emoji: '🎯',
      title: 'People Don\'t Understand What You Actually Do?',
      desc: 'You say you\'re a coach. But people still ask, "So what exactly do you help with?" Ungaluku clarity irukku, but audience ku clarity illa.'
    },
    {
      emoji: '😔',
      title: 'Working Hard But Growth is Slow?',
      desc: 'Neenga hard work pannreenga, but growth slow ah irukkaa? Then it\'s not about effort. It\'s about having the right system.'
    },
    {
      emoji: '🔄',
      title: 'Starting From Zero Every Month?',
      desc: 'Every month feels like you\'re starting from scratch. No consistent pipeline. No predictable income. Just hustle and hope.'
    },
    {
      emoji: '🤯',
      title: 'Confused About What to Fix First?',
      desc: 'You know something\'s not working. But you don\'t know if it\'s your offer, your marketing, your pricing, or your positioning.'
    },
    {
      emoji: '💔',
      title: 'Seeing Others Succeed While You Struggle?',
      desc: 'Other coaches with less experience are getting better clients and charging more. You\'re left wondering, "What am I missing?"'
    }
  ];

  return (
    <motion.section
      className="problem-section"
      initial="initial"
      whileInView="whileInView"
      transition={sectionFadeIn.transition}
      viewport={sectionFadeIn.viewport}
    >
      <div className="container">
        <motion.div className="section-content">
          <motion.h2 {...sectionFadeIn}>
            😰 Coaches: Do You Face These Struggles?
          </motion.h2>
          <motion.p
            className="problem-intro"
            {...sectionFadeIn}
            transition={{ delay: 0.1, ...sectionFadeIn.transition }}
          >
            If you're facing any of these challenges, you're not alone. Most
            coaches struggle with the same issues — not because they lack
            skills, but because they don't have a scalable system.
          </motion.p>
          <motion.div
            className="problem-grid"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
          >
            {problems.map((problem) => (
              <motion.div
                key={problem.title}
                className="problem-card"
                variants={itemVariants}
                whileHover={{ y: -8, transition: { duration: 0.2 } }}
              >
                <h3>
                  {problem.emoji} {problem.title}
                </h3>
                <p>{problem.desc}</p>
              </motion.div>
            ))}
          </motion.div>
        </motion.div>
      </div>
    </motion.section>
  );
}